import { get, MODULE_NAME, post } from '.';

const getChatBotId = async widgetConfiguration => {
    try {
        const publicApps = sessionStorage.getItem(process.env.TCC_SESSION_STORAGE_PUBLIC_APPS);

        if (publicApps) {
            const cachedModuleData = JSON.parse(publicApps).filter(item => {
                return item.name === MODULE_NAME;
            });

            if (cachedModuleData.length) {
                return cachedModuleData[0].app_data.chatbot_id;
            }
        }

        const { company_id, token } = widgetConfiguration;
        // added location so that it can get current path and show offers against that path
        const data = {
            api_key: process.env.WIDGET_API_KEY,
            company_id,
            pathname: window.location.pathname
        };

        const { result } = await post('public_apps_view', data, token);

        const moduleData = result.filter(item => {
            return item.name === MODULE_NAME;
        });

        return moduleData[0]?.app_data.chatbot_id;
    } catch (e) {
        console.log('Failed to get chat bot Id', {
            app: 'chatbot',
            error: e
        });
    }
};

const getChatBot = async (id, token) => {
    try {
        const { result } = await get(`api/chatbot/${id}`, token);

        return result || [];
    } catch (e) {
        console.log('Failed to get chat bot', {
            app: 'chatbot',
            error: e
        });
    }
};

export default {
    getChatBot,
    getChatBotId
};
